export default "__VITE_ASSET__e538ade3__"